<app-modal *ngIf="vo$ | async; let vo">
	<div
		modal-body
		class="app-profile-action-confirm-popup">
		<ng-container [ngSwitch]="vo.action">
			<ng-container *ngSwitchCase="'DELETE_PROFILE'">
				<!-- alert info -->
				<dc-alert
					*ngIf="!vo.isMultipleElement" type="error" message="info"
					i18n-message="@@subscription.profile.action.confirmation.popup.delete.info"></dc-alert>

				<dc-alert
					*ngIf="vo.isMultipleElement" type="error" message="multiple-info"
					i18n-message="@@subscription.profile.action.confirmation.popup.delete.multiple.info"></dc-alert>

				<!-- description request -->
				<span
					*ngIf="!vo.isMultipleElement"
					class="app-profile-action-confirm-popup__description"
					i18n="@@subscription.profile.action.confirmation.popup.delete.description">
					deletion-request</span>
				<span
					*ngIf="vo.isMultipleElement"
					class="app-profile-action-confirm-popup__description"
					i18n="@@subscription.profile.action.confirmation.popup.delete.multiple.description">
					deletion-multiple-request</span>
			</ng-container>

			<ng-container *ngSwitchCase="'UPDATE_PROFILE'">
				<!-- alert info -->
				<dc-alert
					type="warning" message="warn"
					i18n-message="@@subscription.profile.action.confirmation.popup.update.info"></dc-alert>

				<!-- description request -->
				<span
					class="app-profile-action-confirm-popup__description"
					i18n="@@subscription.profile.action.confirmation.popup.update.description">
					update-request</span>
			</ng-container>
		</ng-container>

		<div class="app-profile-action-confirm-popup__element">
			<ng-container *ngIf="!vo.isMultipleElement">
				<span
					i18n="@@subscription.action.confirmation.popup.concernedElement">
					concerned-element</span>

				<span class="app-profile-action-confirm-popup__element-label">
					{{ vo.element | truncate: 30: 1 : 'end' }}</span>
			</ng-container>

			<ng-container *ngIf="vo.isMultipleElement">
				<span
					i18n="@@subscription.action.confirmation.popup.concernedElements">
					concerned-elements</span>

				<div class="app-profile-action-confirm-popup__element-label">
					{{ vo.elementId.length }}
						<span
							i18n="@@subscription.profile.action.confirmation.popup.profiles">
							profiles</span>
				</div>
			</ng-container>
		</div>

		<mat-checkbox
			id="{{ cmpId }}-confirm-delete-checkbox"
			color="primary"
			[(ngModel)]="confirm">
			<span
				*ngIf="vo.action === 'DELETE_PROFILE'"
				i18n="@@subscription.action.confirmation.popup.delete.confirm">
				confirm-delete</span>
			<span
				*ngIf="vo.action === 'UPDATE_PROFILE'"
				i18n="@@subscription.action.confirmation.popup.update.confirm">
				confirm-update</span>
		</mat-checkbox>
	</div>

	<div modal-footer class="app-profile-action-confirm-popup__footer">
		<ng-container [ngSwitch]="vo.action">
			<button
				*ngSwitchCase="'DELETE_PROFILE'"
				id="{{ cmpId }}-delete-btn"
				class="app-profile-action-confirm-popup__footer__btn"
				[color]="'warn'"
				[disabled]="!confirm"
				(click)="launchAction()"
				mat-raised-button>
				<mat-icon [svgIcon]="DcIcons.Delete"></mat-icon>
				<span
					i18n="@@subscription.action.confirmation.popup.delete.btn">
					delete</span>
			</button>

			<button
				*ngSwitchCase="'UPDATE_PROFILE'"
				id="{{ cmpId }}-update-btn"
				class="app-profile-action-confirm-popup__footer__btn"
				[color]="'primary'"
				[disabled]="!confirm"
				(click)="launchAction()"
				mat-raised-button>
				<mat-icon [svgIcon]="DcIcons.Edit"></mat-icon>
				<span
					i18n="@@subscription.action.confirmation.popup.update.btn">
					update</span>
			</button>
		</ng-container>
	</div>
</app-modal>
